module.exports = __webpack_public_path__ + "img/button-add.d14a36a8.svg";